module.exports = __webpack_public_path__ + "img/braking_system_icon.c433c83d.png";